import { useEffect, useState, useRef } from "react";
import { post } from "../js/post";
import { focusElement, userData } from "../js/utils";
import moment from "moment";
import "moment/locale/es";
import {
  salesStatsAgentsTable,
  salesStatsOpticsTable,
} from "../js/tableColumns";
import DataTable from "react-data-table-component";
import InputIconSearch from "./InputIconSearch";
import { DashboardSalesStatsCharts } from "./DashboardSalesStatsCharts";

export function DashboardSalesPanelStatsView({ openCashPopup, active }) {
  useEffect(() => {
    if (active) focusElement(6);
  }, [active]);
  const [opticsRankingList, setOpticsRankingList] = useState([]);
  const [agentsRankingList, setAgentsRankingList] = useState([]);
  const [selectedOptic, setSelectedOptic] = useState({ id: "", name: "" });
  const [selectedAgent, setSelectedAgent] = useState({ id: "", name: "" });
  const [opticsSearchYear, setOpticsSearchYear] = useState(moment());
  const [agentsSearchYear, setAgentsSearchYear] = useState(moment());
  const [opticalSearch, setOpticalSearch] = useState("");
  const [agentSearch, setAgentSearch] = useState("");
  const lastAgentsRequestId = useRef(0);

  const opticsRankingFiltered = opticsRankingList.filter((e) =>
    e.nombreOptica.includes(opticalSearch),
  );
  const agentsRankingFiltered = agentsRankingList.filter((e) =>
    e.nombreApellidosAgente.includes(agentSearch),
  );
  const conditionalRowStylesOpticTable = [
    {
      when: (row) => row.idOptica === selectedOptic.id,
      classNames: ["selected-optic-row"],
    },
  ];

  const conditionalRowStylesAgentTable = [
    {
      when: (row) => row.idAgente === selectedAgent.id,
      classNames: ["selected-optic-row"],
    },
  ];

  async function getOpticsRankingStatsDashboard() {
    const response = await post(
      "/support-extra/dashboard/ObtenerEstadisticasRankingOpticasDashboard.php",
      {
        token: userData.token,
        ano: moment(opticsSearchYear).year(),
      },
    );
    setSelectedOptic(
      response.length > 0
        ? { id: response[0].idOptica, name: response[0].nombreOptica }
        : { id: "", name: "" },
    );
    setOpticsRankingList(response);
  }

  // Agentes de la óptica seleccionada; el primero queda seleccionado
  async function getAgentsRankingStatsDashboard() {
    const requestId = ++lastAgentsRequestId.current;
    const response = await post(
      "/support-extra/dashboard/ObtenerEstadisticasRankingAgentesDashboard.php",
      {
        token: userData.token,
        ano: moment(agentsSearchYear).year(),
        idOptica: selectedOptic.id,
      },
    );
    if (requestId !== lastAgentsRequestId.current) return;
    setSelectedAgent(
      response.length > 0
        ? {
            id: response[0].idAgente,
            name: response[0].nombreApellidosAgente,
          }
        : { id: "", name: "" },
    );
    setAgentsRankingList(response);
  }

  const updatedColumnsOp = salesStatsOpticsTable.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.idOptica ? (
            <button
              onClick={(e) => {
                e.stopPropagation();
                openCashPopup(
                  row.idOptica,
                  "",
                  true,
                  moment(
                    `${moment(opticsSearchYear).format("YYYY")}-01-01`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  moment(
                    `${moment(opticsSearchYear).format("YYYY")}-12-31`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  0,
                  row.nombreOptica,
                  "",
                );
                setSelectedOptic({
                  id: row.idOptica,
                  name: row.nombreOptica,
                });
              }}
              tabIndex={-1}
            >
              Ver más
            </button>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  const updatedColumnsAg = salesStatsAgentsTable.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.idAgente ? (
            <button
              onClick={(e) => {
                e.stopPropagation();
                openCashPopup(
                  "",
                  "",
                  true,
                  moment(
                    `${moment(opticsSearchYear).format("YYYY")}-01-01`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  moment(
                    `${moment(opticsSearchYear).format("YYYY")}-12-31`,
                    "YYYY-MM-DD",
                  ).format("YYYY-MM-DD"),
                  0,
                  row.nombreApellidosAgente,
                  row.idAgente,
                );
                setSelectedAgent({
                  id: row.idAgente,
                  name: row.nombreApellidosAgente,
                });
              }}
              tabIndex={-1}
            >
              Ver más
            </button>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  useEffect(() => {
    getOpticsRankingStatsDashboard();
  }, [opticsSearchYear]);

  useEffect(() => {
    if (selectedOptic.id === "") {
      lastAgentsRequestId.current++;
      setAgentsRankingList([]);
      setSelectedAgent({ id: "", name: "" });
      return;
    }
    getAgentsRankingStatsDashboard();
  }, [agentsSearchYear, selectedOptic.id]);

  return (
    <div className="dashboard-sales-filter">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 40,
          padding: "20px 0",
          width: "100%",
        }}
      >
        {/* Columna de ópticas */}
        <div
          style={{
            width: "50%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <div
            className="dashboard-summary-table"
            style={{ width: "100%", alignItems: "stretch" }}
          >
            <div className="opt-table-title opt-table-title-dash-stats">
              Ranking ópticas {moment(opticsSearchYear).year()}
              <div className="data-field">
                <button
                  className="incdec-btn"
                  tabIndex={-1}
                  onClick={() => {
                    setOpticsSearchYear((prev) =>
                      moment(prev).subtract(1, "year"),
                    );
                  }}
                >
                  {"<"}
                </button>
                <span style={{ width: "60px", textAlign: "center" }}>
                  {moment(opticsSearchYear).year()}
                </span>
                <button
                  className="incdec-btn"
                  tabIndex={-1}
                  onClick={() => {
                    setOpticsSearchYear((prev) => moment(prev).add(1, "year"));
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
            <div className="data-field" style={{ width: "100%" }}>
              <InputIconSearch
                size={0}
                tabIndex={6}
                placeholder={"Óptica"}
                input={opticalSearch}
                onChange={async (e) => {
                  setOpticalSearch(e);
                }}
                onClear={async () => {
                  setOpticalSearch("");
                }}
              ></InputIconSearch>
            </div>
            <DataTable
              columns={updatedColumnsOp}
              data={opticsRankingFiltered}
              className="custom-datatable dashboard-custom-table"
              noDataComponent="No hay datos disponibles."
              conditionalRowStyles={conditionalRowStylesOpticTable}
              onRowClicked={(row) => {
                setSelectedOptic({
                  id: row.idOptica,
                  name: row.nombreOptica,
                });
              }}
            />
            {opticsRankingFiltered.length > 0 && (
              <DataTable
                columns={updatedColumnsOp}
                data={[
                  {
                    idOptica: "",
                    nombreOptica: "",
                    totalVD: opticsRankingFiltered.reduce(
                      (acc, e) => acc + e.totalVD,
                      0,
                    ),
                    beneficio: "",
                  },
                ]}
                className="custom-datatable summary-row no-header-datatable"
              />
            )}
          </div>
          {/* Siempre montada para que la altura no cambie al quedar sin datos */}
          <span className="dashboard-section-or-title">
            {selectedOptic.id !== ""
              ? selectedOptic.id + " - " + selectedOptic.name
              : " "}
          </span>
          <DashboardSalesStatsCharts idOptica={selectedOptic.id} />
        </div>
        {/* Columna de agentes */}
        <div
          style={{
            width: "50%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <div
            className="dashboard-summary-table"
            style={{ width: "100%", alignItems: "stretch" }}
          >
            <div className="opt-table-title  opt-table-title-dash-stats">
              Ranking agentes {moment(agentsSearchYear).year()}
              <div className="data-field">
                <button
                  className="incdec-btn"
                  tabIndex={-1}
                  onClick={() => {
                    setAgentsSearchYear((prev) =>
                      moment(prev).subtract(1, "year"),
                    );
                  }}
                >
                  {"<"}
                </button>
                <span style={{ width: "60px", textAlign: "center" }}>
                  {moment(agentsSearchYear).year()}
                </span>
                <button
                  className="incdec-btn"
                  tabIndex={-1}
                  onClick={() => {
                    setAgentsSearchYear((prev) => moment(prev).add(1, "year"));
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
            <div className="data-field" style={{ width: "100%" }}>
              <InputIconSearch
                size={0}
                tabIndex={7}
                placeholder={"Agente"}
                input={agentSearch}
                onChange={async (e) => {
                  setAgentSearch(e);
                }}
                onClear={async () => {
                  setAgentSearch("");
                }}
              ></InputIconSearch>
            </div>
            <DataTable
              columns={updatedColumnsAg}
              data={agentsRankingFiltered}
              className="custom-datatable dashboard-custom-table"
              noDataComponent="No hay datos disponibles."
              conditionalRowStyles={conditionalRowStylesAgentTable}
              onRowClicked={(row) => {
                setSelectedAgent({
                  id: row.idAgente,
                  name: row.nombreApellidosAgente,
                });
              }}
            />
            {agentsRankingFiltered.length > 0 && (
              <DataTable
                columns={updatedColumnsAg}
                data={[
                  {
                    idAgente: "",
                    nombreApellidosAgente: "",
                    totalVD: agentsRankingFiltered.reduce(
                      (acc, e) => acc + e.totalVD,
                      0,
                    ),
                    beneficio: "",
                  },
                ]}
                className="custom-datatable summary-row no-header-datatable"
              />
            )}
          </div>
          <span className="dashboard-section-or-title">
            {selectedAgent.id !== ""
              ? selectedAgent.id + " - " + selectedAgent.name
              : " "}
          </span>
          <DashboardSalesStatsCharts idAgente={selectedAgent.id} />
        </div>
      </div>
    </div>
  );
}
